import { h } from '@stencil/core';
export class PesCtaAddedToCartLabel {
  constructor() {
    this.active = false;
  }
  render() {
    return (h("pes-slide-down-container", { class: "cta-added-to-cart-label", active: this.active }, h("div", { class: "cta-added-to-cart-label__content" }, h("pes-icon", { class: "cta-added-to-cart-label__icon", size: "medium" }, "notification_ok"), h("span", { class: "cta-added-to-cart-label__text" }, h("slot", null)))));
  }
  static get is() { return "pes-cta-added-to-cart-label"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-cta-added-to-cart-label.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-cta-added-to-cart-label.css"]
    };
  }
  static get properties() {
    return {
      "active": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "active",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
